export default __webpack_public_path__ + "static/media/Adobe1.57f84550.jpg";